import { createSelector } from "reselect";

import { apiPageLimits } from "src/constants";

// Utils
import { buildQueryString } from "src/utils/build_query_string";

/**
 * create a selector to get the api query for admin facility units
 * @returns {function} selector
 */
export function createAdminUnitsQuerySelector() {
  return createSelector(
    () => {
      return apiPageLimits.adminFacilityUnits;
    },
    pageLimit => {
      const query = {
        page: { limit: pageLimit }
      };
      return buildQueryString(query);
    }
  );
}
